import React from "react";

export const COMMON_ALT = "MK Gaming top-notch slot games";
export const COMMON_LOADING = 1500;
export const WEB_PATH = "https://mkvip.co/";
export const WEB = "https://mkvip.co/";
